import Dashboard from "../../../../assets/Dashboard.jsx";
import Organizer from "../../../../assets/Organizer.jsx";
import Team from "../../../../assets/Team.jsx";
import ReviewDoc from "../../../../assets/ReviewDoc.jsx";
import PrepareTax from "../../../../assets/PrepareTax.jsx";
import ReviewTax from "../../../../assets/ReviewTax.jsx";
import FollowUp from "../../../../assets/FollowUp.jsx";
import ReturnToGov from "../../../../assets/ReturnToGov.jsx";
import Clients from "../../../../assets/Clients.jsx";
import TeamConnect from "../../../../assets/TeamConnect.jsx";
import Setting from "../../../../assets/Setting.jsx";
import Communication from "../../../../assets/Communication.jsx";
import Disc from "../../../../assets/Disc.jsx";
import BusinessTask from "../../../../assets/BusinessTask.jsx";
import Templates from "../../../../assets/Templates.jsx";
import Reports from "../../../../assets/Reports.jsx";
import ActivityIcon from "../../../../assets/ActivityIcon.jsx";

export const SidebarData = [
  {
    title: "Dashboard",
    icon: <Dashboard />,
    url: "/dashboard",
    activeUrl: ["/dashboard","/"],
  },
  {
    title: "Organizers",
    icon: <Organizer />,
    url: "/organizers",
    activeUrl: ["/organizers"],
  },
  {
    title: "Verify Doc",
    icon: <ReviewDoc />,
    url: "/verify_doc",
    activeUrl: ["/verify_doc"],
  },
  {
    title: "Prepare Tax",
    icon: <PrepareTax />,
    url: "/prepare_tax",
    activeUrl: ["/prepare_tax"],
  },
  {
    title: "Review Tax",
    icon: <ReviewTax />,
    url: "/review_tax",
    activeUrl: ["/review_tax"],
  },
  {
    title: "Follow Up",
    icon: <FollowUp />,
    url: "/follow_up",
    activeUrl: ["/follow_up"],
  },
  {
    title: "E-file",
    icon: <ReturnToGov />,
    url: "/e_file",
    activeUrl: ["/e_file"],
  },
  // {
  //   title: "Communication",
  //   icon: <Communication />,
  //   url: "/communication",
  //   activeUrl: ["/communication"],
  // },
  {
    title: "Clients",
    icon: <Clients />,
    url: "/clients",
    activeUrl: ["/clients", "/client"],
  },
  {
    title: "Team",
    icon: <Team />,
    url: "/team",
    activeUrl: ["/team"],
  },
  // {
  //   title: "Team Connect",
  //   icon: <TeamConnect />,
  //   url: "/team_connect",
  //   activeUrl: ["/team_connect"],
  // },
  {
    title: "Task",
    icon: <BusinessTask />,
    url: "/task",
    activeUrl: ["/task"],
  },
  {
    title: "Activity Tracker",
    icon: <ActivityIcon />,
    url: "/activity",
    activeUrl: ["/activity"],
  },
  {
    title: "Templates",
    icon: <Templates />,
    activeUrl: ["/organizer_template", "/invoice_template", "/email_template"],
    children: [
      {
        title: "Organizer",
        icon: <Disc />,
        url: "/organizer_template",
        activeUrl: ["/organizer_template"],
      },
      {
        title: "Invoice",
        icon: <Disc />,
        url: "/invoice_template",
        activeUrl: ["/invoice_template"],
      },
      {
        title: "Email",
        icon: <Disc />,
        url: "/email_template",
        activeUrl: ["/email_template"],
      },
    ],
  },
  {
    title: "Reports",
    icon: <Reports />,
    activeUrl: ["/report/organizer"],
    children: [
      {
        title: "Organizer",
        icon: <Disc />,
        url: "/report/organizer",
        activeUrl: ["/report/organizer"],
      },
      {
        title: "Audit Report",
        icon: <Disc />,
        url: "/report/audit_report",
        activeUrl: ["/report/audit_report"],
      },
      {
        title: "Active Job",
        icon: <Disc />,
        url: "/report/active_job",
        activeUrl: ["/report/active_job"],
      },
      {
        title: "Complete Job",
        icon: <Disc />,
        url: "/report/complete_job",
        activeUrl: ["/report/complete_job"],
      },
      {
        title: "Overdue Job",
        icon: <Disc />,
        url: "/report/overdue_task",
        activeUrl: ["/report/overdue_task"],
      },
      {
        title: "Referral Report",
        icon: <Disc />,
        url: "/report/referral",
        activeUrl: ["/report/referral"],
      },
      {
        title: "Payment",
        icon: <Disc />,
        url: "/report/payment",
        activeUrl: ["/report/payment"],
      },
    ],
  },
  {
    title: "Settings",
    icon: <Setting />,
    activeUrl: ["/cells_and_forms", "invoice_template"],
    children: [
      {
        title: "Cells & Forms",
        icon: <Disc />,
        url: "/cells_and_forms",
        activeUrl: ["/cells_and_forms"],
      },
      {
        title: "Tags",
        icon: <Disc />,
        url: "/tags",
        activeUrl: ["/tags"],
      },
      {
        title: "Provinces",
        icon: <Disc />,
        url: "/provinces",
        activeUrl: ["/provinces"],
      },
      {
        title: "FAQ",
        icon: <Disc />,
        url: "/faq",
        activeUrl: ["/faq"],
      },
      {
        title: "Restore User",
        icon: <Disc />,
        url: "/restore_user",
        activeUrl: ["/restore_user"],
      },
      {
        title: "Account",
        icon: <Disc />,
        url: "/settings",
        activeUrl: ["/settings"],
      },
    ],
  },
];
